const config = {
    development: {
        audi: {
            url: "http://localhost:9080",
            client: "audi"
        },
        abraland: {
            url: "http://localhost:9080",
            client: "abraland"
        },
        bmw: {
            url: "http://localhost:9080",
            client: "bmw"
        },
        harley: {
            url: "http://localhost:9080",
            client: "harley"
        },
        triumph: {
            url: "http://localhost:9080",
            client: "triumph"
        },
        vwco: {
            url: "http://localhost:9080",
            client: "vwco"
        },
        bajaj: {
            url: "http://localhost:9080",
            client: "bajaj"
        }
    },
    homolog: {
        audi: {
            url: "https://emplacar-parent-3-6.ciaudibrasil.com.br",
            client: "audi"
        },
        abraland: {
            url: "https://abraland.emplacamento.homologtecsinapse.com",
            client: "abraland"
        },
        bmw: {
            url: "https://emplacar-parent-3-6.bmwbic.com.br",
            client: "bmw"
        },
        harley: {
            url: "https://hdb.emplacamento.homologtecsinapse.com",
            client: "harley"
        },
        triumph: {
            url: "https://triumph.emplacamento.homologtecsinapse.com",
            client: "triumph"
        },
        vwco: {
            url: "https://vwco.emplacamento.homologtecsinapse.com",
            client: "vwco"
        },
        bajaj: {
            url: "https://bajaj.emplacamento.homologtecsinapse.com",
            client: "bajaj"
        }
    },
    production: {
        "https://emplacarapp.ciaudibrasil.com.br": {
            url: "https://emplacamentoaudi.portaltecsinapse.com.br",
            client: "audi"
        },
        "https://emplacarapp.portalabraland.com.br": {
            url: "https://abraland.emplacamento.tecsinapse.com",
            client: "abraland"
        },
        "https://emplacarapp.bmwbic.com.br": {
            url: "https://emplacamentobmw.portaltecsinapse.com.br",
            client: "bmw"
        },
        "https://emplacarapp.portalhdb.com.br": {
            url: "https://hdb.emplacamento.tecsinapse.com",
            client: "harley"
        },
        "https://emplacarapp.portaltriumphbrasil.com.br": {
            url: "https://triumph.emplacamento.tecsinapse.com",
            client: "triumph"
        },
        "https://emplacarapp.portalman.com.br": {
            url: "https://man.emplacamento.tecsinapse.com",
            client: "vwco"
        },
        "https://app.bajaj.emplacar.tecsinapse.com.br": {
            url: "https://bajaj.emplacamento.tecsinapse.com",
            client: "bajaj"
        }
    }
};

export const getClientConfig = (origin, environment) => {
    const clientConfigs = config[environment];

    if (environment === "production") {
        return clientConfigs[origin];
    }

    const baseUrl = origin.replace("http://", "").replace("https://", "");
    const firstDot = baseUrl.indexOf(".");
    const client = baseUrl.substr(0, firstDot);

    return clientConfigs[client];
};
